export function getItemsWithDifferences({
  originalArray,
  newArray,
}: {
  originalArray: any[];
  newArray: any[];
}): any[] {
  const ATTRIBUTES = [
    'editOperation',
    'newTotalCostoDolares',
    'newTotalCostoSoles',
    'totalCostoSoles',
    'totalCostoDolares',
  ];

  console.log({ originalArray, newArray });

  const newArrayMap = new Map(newArray.map((item) => [item.id, item]));

  return originalArray.filter((originalItem) => {
    const newItem = newArrayMap.get(originalItem.id);
    if (!newItem) return false;

    return ATTRIBUTES.some((attr) => originalItem[attr] !== newItem[attr]);
  });
}

export const warningServicioDesactualizado = (
  serviciosDesactualizado: any[]
) => {
  let mensaje =
    serviciosDesactualizado.length > 1 ? 'Los  servicios ' : 'El servicio ';

  mensaje += serviciosDesactualizado
    .map((s) => `${s.nombreServicio}`)
    .join(', ');

  mensaje +=
    serviciosDesactualizado.length > 1
      ? ' tienen modificaciones'
      : ' tiene modificaciones';

  mensaje += '. Por favor, actualiza tu página.';

  return mensaje;
};
